import React, { Component } from 'react';
import ConfiguratorSection from './../ConfiguratorSection';
import ConfiguratorImage from './../ConfiguratorImage';
import ConfiguratorOption from './../ConfiguratorOption';
import Dropdown from './../Dropdown';
import Disclaimer from '../Disclaimer';
import TransomConfigurator from './../TransomConfigurator';
import RadioGroup from './../RadioGroup';
import { withTranslation, Trans } from 'react-i18next';
import { view01ImageOptions } from './views/view01'

class Color extends Component {
    constructor(props) {
        super(props);

        this.handleHullColorChange = this.handleHullColorChange.bind(this);
        this.handleTTopChange = this.handleTTopChange.bind(this);
        this.handleEngineChange = this.handleEngineChange.bind(this);
    }

    handleTTopChange(newValue) {
        let configuration = this.props.configuration;
        configuration.TTop = newValue;

        if (this.props.onChange) {
            this.props.onChange(configuration);
        }
    }

    componentWillUnmount() {
        clearTimeout(this.timer);
    }

    handleHullColorChange(newValue) {
        let configuration = this.props.configuration;
        configuration.HullColour = newValue;


        if (this.props.onChange) {
            this.props.onChange(configuration);
        }
    }

    handleEngineChange(newValue) {
        let configuration = this.props.configuration;
        configuration.Engine = newValue;

        if (this.props.onChange) {
            this.props.onChange(configuration);
        }
    }


    render() {
        let imageOptions = view01ImageOptions;

        let image = (
            <TransomConfigurator colorMultiplier={0.75} name={this.props.transom.Name} port={this.props.transom.Port} transomSize={{ width: 920, height: 220 }} transform={
                [
                    0.023205, -0.020868, 0, -0.000126,
                    -0.071803, 0.001307, 0, -0.000277,
                    0, 0, 1, 0,
                    244, 350, 0, 1
                ]}>
                <ConfiguratorImage boat="Xpower" configuration={this.props.configuration} options={imageOptions} />
            </TransomConfigurator>
        );

        return (
            <ConfiguratorSection image={image}>

                <ConfiguratorOption style={{ position: 'relative' }}>
                    <h1><Trans defaults='Color scheme' /></h1>

                    <h2><Trans defaults='Hull' /></h2>
                    <p><Trans defaults='X-Power hulls are built using the latest high-tech construction technologies with vacuum-infused vinylester.' /></p>

                    <Dropdown options={this.props.hullColourOptions} onChange={this.handleHullColorChange} value={this.props.configuration.HullColour} style={{ maxWidth: 472 }} />

                    <p>
                        <img style={{ border: '1px solid #c2c2c2' }} src={this.props.configuration.HullColour.preview} alt={this.props.configuration.HullColour.label} />
                    </p>

                    
                    <h1><Trans defaults='T-Top' /></h1>
                    <p><Trans defaults='The X-Power 33C has an optional T-Top, creating the perfect protection from both sun and wind along the standard windscreen. A bimini and cockpit tent are optional.' /></p>

                    <RadioGroup options={this.props.TTopOptions} value={this.props.configuration.TTop} onChange={this.handleTTopChange} />

                    <h1><Trans defaults='Drivetrain' /></h1>
                    <p><Trans defaults='The X-Power 33C powerboat is either equipped with a powerful inboard Yanmar 8LV engine or an outboard Mercury/Yamaha engine:' /></p>
                    <h2><Trans defaults='Choose your engine type:' /></h2>

                    <RadioGroup options={this.props.EngineOptions} value={this.props.configuration.Engine} onChange={this.handleEngineChange} />
                   
                    <Disclaimer />


                </ConfiguratorOption>
            </ConfiguratorSection>
        );
    }
}

export default withTranslation()(Color);


// WEBPACK FOOTER //
// ./src/Xpower/Color.js